import PaginatedTableBalanzaIngresos from '../../components/reportes/balanza/PaginatedTableBalanzaIngresos';
import { Row, Col } from 'antd';
import { useState } from 'react';
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import StackGenericBarchart from '../../components/reportes/GenericStackBarchart';
import GenericHorizontalBarchart from '../../components/reportes/GenericHorizontalBarchart';
import { createCountByKeyDataset, createSumDataset } from '../../utils/datasetCalculator';
import { PageTitle, StatCard, StatCardsContainer } from '../../components/common';
import { theme } from '../../theme';

const IngresoCamiones = () => {  

    const [nro_cliente, setNroCliente] = useState("all");
    const [totalTickets, setTotalTickets] = useState(0);
    const [totalKgAlgodonBruto, setTotalAlgodonBruto] = useState(0);
    const [totalDesmotado, setTotalDesmotado] = useState(0);
    const [totalNoDesmotado, setTotalNoDesmotado] = useState(0);
    const [barchartDataDesmotado, setBarchartDataDesmotado] = useState([]);
    const [barchartLabels, setBarchartLabels] = useState([]);
    const [barchartDataNoDesmotado, setBarchartDataNoDesmotado] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [fullTableData, setFullTableData] = useState([]);
    const {user} = useAuth0();

    const tipo_usuario = user?.tipo_usuario;

    const balanzaChartData = createSumDataset(fullTableData, 'cliente', 'peso', 'Kg. Algodón Bruto', 'rgb(0, 125, 173)', {limit: 10});
    const camionesEnviadosChartData = createCountByKeyDataset(fullTableData, 'transportista', 'Camiones Enviados', '#98BF06', {limit: 10});

    return (
      <div style={{ padding: '0' }}>
        <PageTitle>Ingreso de Camiones</PageTitle>
        <StatCardsContainer gap={16} minColumnWidth="200px">
          <StatCard
            title="Tickets Totales"
            value={totalTickets}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
          <StatCard
            title="Total Algodón Bruto"
            value={totalKgAlgodonBruto}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
          <StatCard
            title="Tickets Desmotados"
            value={totalDesmotado}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
          <StatCard
            title="Tickets No Desmotados"
            value={totalNoDesmotado}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
        </StatCardsContainer>
        {tipo_usuario === "D" && (
          <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
            <Col xs={24} lg={24}>
              <div style={{ 
                width: '100%', 
                height: '300px',
                borderRadius: theme.styles.borderRadius,
                boxShadow: theme.styles.boxShadowLight,
                backgroundColor: '#fff'
              }}>
                <StackGenericBarchart
                  title={"Tickets Desmotados/No Desmotados por Cliente"}
                  bardata_desmotado={barchartDataDesmotado}
                  bardata_no_desmotado={barchartDataNoDesmotado}
                  labels={barchartLabels}
                  dataset_desmotado_label={"Desmotado"}
                  dataset_no_desmotado_label={"No Desmotado"}/>
              </div>
            </Col>
          </Row>
        )}
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
          <Col xs={24} lg={12}>
            <div style={{ 
              width: '100%', 
              height: '300px',
              borderRadius: theme.styles.borderRadius,
              boxShadow: theme.styles.boxShadowLight,
              backgroundColor: '#fff'
            }}>
              <GenericHorizontalBarchart
                title="Top 10 Clientes - Kg. Algodón Bruto"
                labels={balanzaChartData.labels}
                datasets={balanzaChartData.datasets}
              />
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div style={{ 
              width: '100%', 
              height: '300px',
              borderRadius: theme.styles.borderRadius,
              boxShadow: theme.styles.boxShadowLight,
              backgroundColor: '#fff'
            }}>
              <GenericHorizontalBarchart
                title="Top 10 Transportistas - Camiones Enviados"
                labels={camionesEnviadosChartData.labels}
                datasets={camionesEnviadosChartData.datasets}
              />
            </div>
          </Col>
        </Row>
        <Row className='my-4'>
          <Col xs={24} md={24} lg={24}>
            <PaginatedTableBalanzaIngresos
              getNroCliente={setNroCliente}
              csvName={"reporte_balanza.xlsx"}
              getTotalTickets={setTotalTickets}
              getKgAlgodonTotales={setTotalAlgodonBruto}
              getTotalDesmotado={setTotalDesmotado}
              getTotalNoDesmotado={setTotalNoDesmotado}
              getBarchartDataDesmotado={setBarchartDataDesmotado}
              getBarchartLabels={setBarchartLabels}
              getBarchartDataNoDesmotado={setBarchartDataNoDesmotado}
              getIsLoading={setIsLoading}
              getFullTableData={setFullTableData}
            />      
          </Col>
        </Row>
      </div>
    );
};

export default withAuthenticationRequired(IngresoCamiones);
